import styled from 'styled-components';
import { mediaQueries } from '@fourthwall/components';
export const Container = styled.div `
  border-top: 1px solid var(--border-secondary);
  border-bottom: 1px solid var(--border-secondary);

  ${mediaQueries.tablet} {
    border: 1px solid var(--border-secondary);
    border-radius: var(--radius-brand);

    transition: border-color var(--motion-duration-100) var(--motion-ease-in-out);

    &:hover {
      border-color: var(--border-secondary-hover);
    }
  }
`;
export const Header = styled.div `
  display: flex;

  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  border-bottom: ${({ $noProgressBar }) => $noProgressBar ? 'none' : '1px solid var(--border-secondary)'};
  padding: var(--space-400);

  ${mediaQueries.tablet} {
    padding: var(--space-500);
  }
`;
export const Headings = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
`;
export const Title = styled.div `
  font-family: var(--font-family-heading);
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-300); /* 125% */
  letter-spacing: var(--font-letter-spacing-dense);
  text-wrap: balance;

  ${mediaQueries.tablet} {
    font-size: var(--font-size-500);
    line-height: var(--font-line-height-400);
    letter-spacing: var(--font-letter-spacing-denser);
  }
`;
export const Subtitle = styled.div `
  color: var(--text-secondary);
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);

  ${mediaQueries.tablet} {
    font-size: var(--font-size-400);
    line-height: var(--font-line-height-400);
    letter-spacing: var(--font-letter-spacing-normal);
  }
`;
export const Description = styled.div `
  color: var(--text-secondary);
  font-size: var(--font-size-300);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300); /* 142.857% */
  letter-spacing: var(--font-letter-spacing-loose);

  ${mediaQueries.tablet} {
    font-size: var(--font-size-400);
    font-weight: var(--font-weight-regular);
    line-height: var(--font-line-height-400); /* 150% */
    letter-spacing: var(--font-letter-spacing-normal);
  }

  a {
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    text-decoration-thickness: auto;
    text-underline-offset: 25%;
    text-underline-position: from-font;
  }
`;
export const Buttons = styled.div `
  display: flex;
  gap: 12px;
  margin-top: 10px;
`;
export const CircleProgress = styled.div `
  position: relative;

  display: flex;

  align-self: flex-start;

  border-radius: 50%;

  width: 52px;
  height: 52px;

  background: conic-gradient(
    var(--border-success) calc(var(--progress)),
    var(--border-secondary) 0deg
  );

  &::after {
    content: '';

    display: flex;

    justify-content: center;
    flex-direction: column;

    margin: 3px;
    border-radius: 50%;

    width: 54px;

    background: var(--bg-primary);
  }
`;
export const CircleProgressText = styled.div `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-400);
`;
